function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';
import { DatepickerInputStyled } from './styled';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
registerLocale('fr-FR', fr);
const DatepickerInput = _ref => {
  let {
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(DatepickerInputStyled, {
    className: className
  }, /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, props, {
    locale: "fr-FR"
  })));
};
export default DatepickerInput;